import React, { useState } from "react";
import styles from "./table.module.sass";
import cn from "classnames";
import Checkbox from "../../../Checkbox";
import Row from "./Row";


const Table = ({items, access, title, type, setValue }) => {

  return (
    <div className={styles.wrapper}>
      <div className={styles.table}>
        <div className={styles.row}>
          <div className={styles.col}>Transaction Date</div>
          <div className={styles.col}>Transaction Time</div>
          <div className={styles.col}>Transaction Amount</div>
          <div className={styles.col}>Transaction Contact</div>
          <div className={styles.col}>Transaction Type</div>
          <div className={styles.col}>Transaction Source</div>
          <div className={styles.col}>Transaction Recipient</div>
          <div className={styles.col}>Transaction Purpose</div>
          <div className={styles.col}>Transaction Event</div>
          <div className={styles.col}>Transaction Status</div>
          <div className={styles.col}>Transaction Mode</div>
        </div>
        {items && items.map((x, index) => (
          <Row access={access} setValue={setValue} type={type} item={x} key={index} index={index} />
        ))}
      </div>
    </div>
  );
};

export default Table;
